
import { NgModule } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { CanDeactivateGuard } from '../../guards/can-deactivate-guard.service';

import { ProjectSupportComponent } from './projectSupport.component';
import { ViewDrawingsComponent } from './viewDrawings.component';
import { DrawingComponent } from './drawing.component';
import { ViewOpenCarsComponent } from './qualityControl/observations/view-open-cars/view-open-cars.component';
import { ViewClosedCarsComponent } from './qualityControl/observations/view-closed-cars/view-closed-cars.component';
import { ViewNotValidCarsComponent } from './qualityControl/observations/view-not-valid-cars/view-not-valid-cars.component';
import { ViewOpenCdisComponent } from './qualityControl/observations/view-open-cdis/view-open-cdis.component';
import { ViewClosedCdisComponent } from './qualityControl/observations/view-closed-cdis/view-closed-cdis.component';
import { ViewNotValidCdisComponent } from './qualityControl/observations/view-not-valid-cdis/view-not-valid-cdis.component';
import { ObservationComponent } from './qualityControl/observations/observation/observation.component';
import { ViewWasteDrumsComponent } from './viewWasteDrums.component';
import { EnvironmentalConfigComponent } from './environmental-config/environmental-config.component';
import { OaProjectsComponent } from './engineering/oa-projects/oa-projects.component';
import { OaComponent } from './engineering/oa/oa.component';
import { EngineeringConfigComponent } from './engineering/engineering-config/engineering-config.component';
import { QualityControlConfigComponent } from './qualityControl/quality-control-config/quality-control-config.component';
import { ReportScheduleComponent } from './qualityControl/report-schedule/report-schedule.component';
import { QuestionComponent } from './qualityControl/checklist/question.component';
import { ReportScheduleAsRequiredComponent } from './qualityControl/report-schedule-as-required/report-schedule-as-required.component';
import { InspectionReportComponent } from './qualityControl/inspection-report/inspection-report.component';
import { ViewInpectionReportsComponent } from './qualityControl/inspection-report/view-inspection-reports.component';

const engineeringRoutes: Routes = [
  {
    path: "",
    component: ProjectSupportComponent,
    children: [
      {
        path: '',
        children: [
          { path: './', redirectTo: "", pathMatch: "full" },
          { path: '', component: ViewOpenCarsComponent },
          { path: 'drawing', component: DrawingComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'drawing/:drawingId', component: DrawingComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'viewDrawings', component: ViewDrawingsComponent },
          { path: 'viewOpenCars', component: ViewOpenCarsComponent },
          { path: 'viewClosedCars', component: ViewClosedCarsComponent },
          { path: 'viewNotValidCars', component: ViewNotValidCarsComponent },
          { path: 'viewOpenCdis', component: ViewOpenCdisComponent },
          { path: 'viewClosedCdis', component: ViewClosedCdisComponent },
          { path: 'viewNotValidCdis', component: ViewNotValidCdisComponent },
          { path: 'observation', component: ObservationComponent },
          { path: 'observation/:observationId', component: ObservationComponent },
          { path: 'viewWasteDrums', component: ViewWasteDrumsComponent },
          { path: 'environmentalConfig', component: EnvironmentalConfigComponent },
          { path: 'oaProjects', component: OaProjectsComponent },
          { path: 'oa', component: OaComponent },
          { path: 'oa/:oaNum', component: OaComponent },
          { path: 'engineeringConfig', component: EngineeringConfigComponent },
          { path: 'qualityControlConfig', component: QualityControlConfigComponent },
          { path: 'reportSchedules', component: ReportScheduleComponent },
          { path: 'asReqReportSchedules', component: ReportScheduleAsRequiredComponent },
          { path: 'questions', component: QuestionComponent },
          { path: 'inspectionReport', component: InspectionReportComponent },
          { path: 'inspectionReport/:inspectionReportId', component: InspectionReportComponent },
          { path: 'viewInspectionReports', component: ViewInpectionReportsComponent }
        ]
      }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(engineeringRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ProjectSupportRoutingModule { }
